import { createAsyncThunk } from "@reduxjs/toolkit";

import coreAPIs from "../../../services/api/core";

export const bulkGenerateAudioContentVariant = createAsyncThunk("core/contentVariant/generate", async (payload) => {
  try {
    const response = await coreAPIs.bulkGenerateAudioVariant(payload);

    return response.data;
  } catch (error) {
    console.error(error);
  }
});

export const listContentVariants = createAsyncThunk("core/contentVariant/list", async (payload) => {
  try {
    const response = await coreAPIs.listContentVariants(payload);

    return response.data;
  } catch (error) {
    console.error(error);
  }
});

export const deleteContentVariant = createAsyncThunk("core/contentVariant/delete", async (payload) => {
  try {
    const response = await coreAPIs.deleteContentVariant(payload);

    return response.data;
  } catch (error) {
    console.error(error);
  }
});
